import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_LB } from '$Deposits/store/actions/DepositPost'
import { SetDepositMoneyStatus, SetUploadFileErr, SetDepositNextStep, PostConfirmStep, GetDepositAccountByAmount, PostMemberCancelDeposit, UpdateMemberDepositStepTwoCompleted, SetDepositTimer } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'



class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalUniqueAmt: false,
            isCountdownFinish: false,
            cancelModal: false
        };
    }

    componentDidMount() {
        if(this.props.MethodCodeActive == 'UniqueAmt') {
            this.setState({isModalUniqueAmt: true})
        }
    }
    componentWillUnmount() {

    }
    render() {
        const { LivechatClick, webPiwikEvent } = GetParamsData()

        const {
            DepositBankActive,
            MethodsActive,
            DepositMoneyStatus,
            SetDepositNextStep,
            NextStep,
            SetDepositPayments_LB,
            MethodCodeActive,
            DepositPayments,
            PostConfirmStep,
            Modal,
            MethodsDetails,
            DepositAccountByAmount,
            ModalUniqueAmt,
            ModalCancel,
            GetDepositAccountByAmount,
            PostMemberCancelDeposit,
            UpdateMemberDepositStepTwoCompleted,
            DepositMisc,
            DepositTimer,
            SetDepositMoneyStatus,
            DepositTimeSelect
        } = this.props

        const { isCountdownFinish, cancelModal, isModalUniqueAmt } = this.state
        const { money } = DepositMoneyStatus || {}
        let isDummyBank = DepositAccountByAmount?.isDummyBank ?? true
        let showDate = true
        if(MethodCodeActive == 'UniqueAmt') {
            isDummyBank = DepositPayments?.isDummyBank ?? false
            showDate = false
        }
        const { setting = {} } = MethodsDetails || {}

        console.log('************************************ PROPS ************************************', this.props)
        return (
            <>
                <ModalUniqueAmt
                    modalVisible={!isDummyBank && isModalUniqueAmt && !DepositMisc?.isSkipStep1}
                    title={'แจ้งเตือน'}
                    okText={'ปิด'}
                    msg={`กรุณาโอนเงินเป็นจำนวนทศนิยมตามที่ระบบกำหนดเท่านั้นเพื่อความรวดเร็วในการตรวจสอบและอนุมัติยอดเงิน`}
                    onChange={() => { this.setState({isModalUniqueAmt: false}) }}
                />
                <Modal
                    modalVisible={!isDummyBank && isCountdownFinish}
                    header={false}
                    okText={'ตกลง'}
                    msg={`ขออภัย\nคุณไม่ได้ทำรายการฝากเงินภายในเวลาที่กำหนด\nกรุณาทำรายการอีกครั้ง`}
                    onChange={() => {
                        SetDepositNextStep()
                        SetDepositMoneyStatus('', '', true)
                    }}
                />
                {/* <Modal
                    modalVisible={isDummyBank && !DepositMisc?.isSkipStep1}
                    title={'การฝากเงินล้มเหลว'}
                    header={true}
                    okText={'ทำการฝากใหม่'}
                    cancelText={"ปิด"}
                    msg={`ขออภัยไม่มีธนาคารให้บริการในขณะนี้ รายการฝากนี้ จะถูกยกเลิก กรุณาทำรายการฝากด้วยช่องทางอื่น`}
                    onChange={() => {
                        SetDepositNextStep()
                        SetDepositMoneyStatus('', '', true)
                        GetDepositAccountByAmount(true)
                    }}
                /> */}
                <ModalCancel
                    modalVisible={cancelModal}
                    modes={'warning'}
                    msg={'คุณยืนยันที่จะยกเลิกการฝากเงินนี้หรือไม่'}
                    cancelText={'ไม่ยกเลิก'}
                    okText={'ยืนยันยกเลิก'}
                    onCancel={() => { this.setState({cancelModal: false}) }}
                    onOk={() => {
                        if(MethodCodeActive == 'UniqueAmt'){
                            PostMemberCancelDeposit(true)
                        } else{
                            UpdateMemberDepositStepTwoCompleted()
                        }
                        this.setState({ cancelModal: false })
                    }}
                />
                <NextStep
                    DepositMisc={DepositMisc}
                    DepositTimer={DepositTimer}
                    DepositBankActive={DepositBankActive}
                    DepositPayments={DepositPayments}
                    MethodsActive={MethodsActive}
                    MethodCodeActive={MethodCodeActive}
                    DepositTimeSelect={DepositTimeSelect}
                    backClick={() => { SetDepositNextStep() }}
                    onChange={() => {
                        if (MethodCodeActive == 'UniqueAmt') {
                            //UniqueAmt渠道
                            PostConfirmStep(DepositPayments)
                        } else {
                            SetDepositPayments_LB()
                        }
                    }}
                    onCancel={() => {
                        this.setState({
                            cancelModal: true
                        })
                    }}
                    money={money}
                    SetDepositNextStep={SetDepositNextStep}
                    LivechatClick={()=>{
                        LivechatClick()
                        webPiwikEvent("Deposit", "Contact CS", `Deposit_LB_${MethodCodeActive}_C_CS`)
                    }}
                    DepositAccountByAmount={DepositAccountByAmount}
                    setting={setting}
                    showDate={showDate}
                    onCountdownFinish={
                        () => {
                            this.props.SetDepositTimer('')
                            this.setState({isCountdownFinish: true})
                        }
                    }
                />


            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositMoneyStatus: state.DepositMoneyStatus,
    MethodsActive: state.MethodsActive,
    DepositBankActive: state.DepositBankActive,
    MethodCodeActive: state.MethodCodeActive,
    DepositPayments: state.DepositPayments,
    DepositAccountByAmount: state.DepositAccountByAmount,
    MethodsDetails: state.MethodsDetails,
    DepositTimer: state.DepositTimer,
    DepositMisc: state.DepositMisc,
    DepositTimeSelect: state.DepositTimeSelect,
});
const mapDispatchToProps = {
    SetDepositTimer: () => SetDepositTimer(),
    PostMemberCancelDeposit: (data) => PostMemberCancelDeposit(data),
    SetUploadFileErr: (data) => SetUploadFileErr(data),
    SetDepositNextStep: (data = false) => SetDepositNextStep(data),
    SetDepositPayments_LB: (data = {}) => SetDepositPayments_LB(data),
    PostConfirmStep: (data = {}) => PostConfirmStep(data),
    GetDepositAccountByAmount: (data) => GetDepositAccountByAmount(data),
    UpdateMemberDepositStepTwoCompleted: () => UpdateMemberDepositStepTwoCompleted(),
    SetDepositMoneyStatus: (money, details = {}, refresh = true) => SetDepositMoneyStatus(money, details, refresh),
};
export default connect(mapStateToProps, mapDispatchToProps)(NextStep);

